import { AfterViewInit, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ReactiveFormsModule, FormsModule, FormGroup, FormArray, FormControl, Validators } from '@angular/forms';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatFormFieldModule, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule, MatPaginator } from '@angular/material/paginator';
import { MatTableModule, MatTableDataSource } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { ActivatedRoute, RouterLink } from '@angular/router';
import { NgSelectModule } from '@ng-select/ng-select';
import { NgToggleModule } from 'ng-toggle-button';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { PAGELENGTH } from 'src/app/endpoints';
import { CardComponent } from 'src/app/shared/components/card/card.component';
import { CategoryService } from 'src/app/shared/service/category/category.service';
import { SampleService } from 'src/app/shared/service/sample/sample.service';
import { UserServiceService } from 'src/app/shared/service/userService/user-service.service';
import { UserDataService } from 'src/app/shared/service/userData/user-data.service';
import { NgClass } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
declare var bootstrap: any;

@Component({
  selector: 'app-assign-sample',
  imports: [
    CardComponent,
    MatTableModule,
    MatPaginatorModule,
    NgToggleModule,
    MatIcon,
    ReactiveFormsModule,
    NgSelectModule,
    MatTabsModule,
    FormsModule,
    MatFormFieldModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatLabel,
    MatInputModule,
    RouterLink,
    MatCardModule,
    NgClass
  ],
  templateUrl: './assign-sample.component.html',
  styleUrl: './assign-sample.component.scss'
})
export class AssignSampleComponent implements OnInit, AfterViewInit {

  // Modal and pagination properties
  assignSampleModal: any;
  startpoint: number = 0;
  search: any;
  totalLoaded: number = 0;
  total: any;
  pageNo: any;

  // Data properties
  sampleId: any;
  companyId: any;
  sampleData: any;
  wholeSalerTotal: any;
  retailerTotal: any;

  // Arrays for storing data
  allWholesalersMini: any[] = [];
  allRetailersMini: any[] = [];
  allCategoriesMini: any;

  // Tracking state
  newQuantityAssignedMap: { [rowId: string]: number } = {};
  currentTabIndex: number = 0;

  // Data sources for tables
  wholeSalerdataSource = new MatTableDataSource<any>([]);
  retailerDataSource = new MatTableDataSource<any>([]);
  distributorsDataSource = new MatTableDataSource<any>([]);

  // Table column definitions
  displayedColumns: string[] = ['srno', 'name', 'issued', 'remainingInventory', 'limit', 'issue'];
  distributorsdisplayedColumns: string[] = ['name', 'email', 'action'];

  // View children references
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatPaginator) wholeSalerPaginator: MatPaginator;
  @ViewChild(MatPaginator) retailerPaginator: MatPaginator;
  @ViewChild('fileInput') fileInput: ElementRef;

  // Form controls
  issueSampleForm = new FormGroup({
    rows: new FormArray([])
  });

  // Search functionality
  debounceNameTimer: any = null;
  distributorSearch: any = {
    name: '',
  };

  constructor(
    private sampleService: SampleService,
    private categoryService: CategoryService,
    private userService: UserServiceService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
    private activatedRoute: ActivatedRoute,
    private userDataService: UserDataService
  ) { }

  // Lifecycle hooks
  ngOnInit(): void {
    this.sampleId = this.activatedRoute.snapshot.paramMap.get("_id");
    this.companyId = this.userDataService.getData().company?._id ?? '';
    this.getAllIssuedSampleToWholeSaler(null);
    this.getSingleSample();
  }

  ngAfterViewInit() {
    this.initializeModal();
    this.initializePaginators();
  }

  // Helper methods
  private initializeModal() {
    const sampleModalElement = document.getElementById('assignSampleModal');
    if (sampleModalElement) {
      this.assignSampleModal = new bootstrap.Modal(sampleModalElement);
    }
  }

  private initializePaginators() {
    this.wholeSalerdataSource.paginator = this.wholeSalerPaginator;
    this.retailerDataSource.paginator = this.retailerPaginator;
  }

  // Tab handling
  onTabChange(index: number) {
    this.currentTabIndex = index;
    this.clearRows();

    if (index === 0) {
      this.getAllIssuedSampleToWholeSaler(null);
    } else {
      this.getAllIssuedSampleToRetailer(null);
    }
  }

  // Modal operations
  openModel() {
    if (this.currentTabIndex === 0) {
      this.wholerSalersMini();
    } else {
      this.retailersMini();
    }
    this.assignSampleModal.show();
  }

  hideModel() {
    this.issueSampleForm.reset();
    this.rows.clear();
    this.assignSampleModal.hide();
  }

  // Search functionality
  onNameInputChange(event: any): void {
    clearTimeout(this.debounceNameTimer);
    this.debounceNameTimer = setTimeout(() => {
      const name = event.target.value;
      this.distributorSearch.name = name || undefined;

      if (this.currentTabIndex === 0) {
        this.wholerSalersMini();
      } else {
        this.retailersMini();
      }
    }, 300);
  }

  // Data fetching methods
  wholerSalersMini() {
    this.spinner.show();
    this.distributorsDataSource.data = [];

    let data: any = {
      sampleId: this.sampleId,
      receiverType: 1,
      companyId: this.companyId
    };

    this.userService.allDistributorMini(data).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.total = result.total ?? 0;
          this.distributorsDataSource.data = [...this.distributorsDataSource.data, ...(result.data || [])];
          data = this.distributorsDataSource.data;
          this.distributorsDataSource.data = data.filter((item: any) =>
            item?.distributorId?.name?.toLowerCase().includes(this.distributorSearch.name.toLowerCase())
          );
        }
      },
      error: (e: any) => {
        this.handleError(e);
      },
      complete: () => this.spinner.hide()
    });
  }

  retailersMini() {
    this.spinner.show();
    this.distributorsDataSource.data = [];

    let data: any = {
      sampleId: this.sampleId,
      receiverType: 2,
      companyId: this.companyId
    };

    this.userService.allDistributorMini(data).subscribe({
      next: (result) => {
        this.spinner.hide();
        if (result.success) {
          this.total = result.total ?? 0;
          this.distributorsDataSource.data = [...this.distributorsDataSource.data, ...(result.data || [])];
          data = this.distributorsDataSource.data;
          this.distributorsDataSource.data = data.filter((item: any) =>
            item?.distributorId?.name?.toLowerCase().includes(this.distributorSearch.name.toLowerCase())
          );
        }
      },
      error: (e: any) => {
        this.handleError(e);
      },
      complete: () => this.spinner.hide()
    });
  }

  // Error handling
  private handleError(e: any) {
    this.spinner.hide();
    let errorMsg = "Server not reachable. Try again later.";

    if (e.status !== 0) {
      errorMsg = e.message || 'An unexpected error occurred.';
    }

    this.toastr.error(errorMsg, 'Error');
  }

  // Sample data operations
  getSingleSample() {
    this.spinner.show();
    this.sampleService.singleSample({ _id: this.sampleId }).subscribe({
      next: v => {
        if (v.success) {
          this.sampleData = v.data;
        }
      },
      error: e => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }

  // Data loading methods
  getAllIssuedSampleToWholeSaler(event: any) {
    this.loadIssuedSamples(event, 1);
  }

  getAllIssuedSampleToRetailer(event: any) {
    this.loadIssuedSamples(event, 2);
  }

  private loadIssuedSamples(event: any, receiverType: number) {
    this.spinner.show();

    if (event === null) {
      this.startpoint = 0;
      if (receiverType === 1) {
        this.wholeSalerdataSource.data = [];
      } else {
        this.retailerDataSource.data = [];
      }
    }

    let data: any = {
      startpoint: this.startpoint,
      receiverType,
      issuerDistributorId: null,
      sampleId: this.sampleId,
      ...(!!this.search && { search: this.search })
    };

    const isRetailer = receiverType === 2;
    const total = isRetailer ? this.retailerTotal : this.wholeSalerTotal;
    const dataSource = isRetailer ? this.retailerDataSource : this.wholeSalerdataSource;
    const paginator = isRetailer ? this.retailerPaginator : this.wholeSalerPaginator;

    if (this.totalLoaded === 0 || event === null || (this.totalLoaded < total && (event.pageIndex > this.pageNo))) {
      this.sampleService.allIssuedSamples(data).subscribe({
        next: result => {
          if (result.success) {
            if (isRetailer) {
              this.retailerTotal = result.total ?? 0;
            } else {
              this.wholeSalerTotal = result.total ?? 0;
            }

            dataSource.data = [...dataSource.data, ...(result.data || [])];
            this.totalLoaded = dataSource.data.length;
            this.startpoint = this.totalLoaded;
            this.pageNo = paginator?.pageIndex;

            setTimeout(() => {
              paginator.length = total;
              paginator.pageSize = PAGELENGTH;
              paginator._changePageSize;
            }, 10);
          }
        },
        error: e => this.toastr.error(e),
        complete: () => this.spinner.hide()
      });
    } else {
      this.spinner.hide();
    }
  }

  // Form array operations
  get rows() {
    return this.issueSampleForm.get('rows') as FormArray;
  }

  addRow(distributor: any) {
    const distributorId = distributor?.distributorId?._id;
    const alreadyExists = this.rows.controls.some((control) => {
      return control.get('receiverDistributorId')?.value === distributorId;
    });

    if (alreadyExists) {
      return;
    }

    let limitValue = 0;

    if (this.currentTabIndex === 0) {
      limitValue = this.sampleData?.maxIssueQuantityWholesaler ?? 0;
    } else {
      limitValue = this.sampleData?.maxIssueQuantityRetailer ?? 0;
    }

    const newRow = new FormGroup({
      receiverDistributorId: new FormControl(distributorId, Validators.required),
      distributorName: new FormControl(distributor?.distributorId?.name || ''),
      distributorEmail: new FormControl(distributor?.distributorId?.email || ''),
      quantityAssigned: new FormControl('', [
        Validators.required,
        Validators.min(1),
        Validators.max(limitValue)
      ]),
      distributorLimit: new FormControl(limitValue, [
        Validators.required,
        Validators.min(limitValue),
      ])
    });

    this.rows.push(newRow);
  }

  removeRow(index: number) {
    this.rows.removeAt(index);
  }

  clearRows() {
    this.rows.clear();
  }

  // Edit operations
  enableEdit(row: any) {
    row.editMode = true;
    row.originalQuantityAssigned = this.newQuantityAssignedMap[row._id];
  }

  saveEdit(row: any) {
    row.editMode = false;
    const newQty = this.newQuantityAssignedMap[row._id];

    if (row.originalQuantityAssigned !== newQty) {
      this.submitRows(row);
    }

    this.newQuantityAssignedMap[row._id] = null;
  }

  onBlur(row: any) {
    this.saveEdit(row);
  }

  enableLimitEdit(row: any) {
    row.limitEditMode = true;
    row.originalDistributorLimit = row.distributorLimit;
  }

  showLimitMessage = false;

  saveLimitEdit(row: any) {
    row.limitEditMode = false;
    this.showLimitMessage = true;

    if (row.originalDistributorLimit !== row.distributorLimit) {
      this.submitRows(row);
    }
  }

  // Bulk operations
  selectAllSamples() {
    for (const distributor of this.distributorsDataSource.data) {
      this.addRow(distributor);
    }
  }

  // Form submission
  submitRows(element: any) {
    this.spinner.show();
    const receiverType = this.currentTabIndex === 0 ? 1 : 2;
    let data: any;

    if (element) {
      const newQty = this.newQuantityAssignedMap[element._id];
      data = {
        receiverType,
        sampleList: [{
          sampleId: element.sampleId?._id,
          receiverDistributorId: element.receiverDistributorId?._id,
          distributorLimit: element.distributorLimit,
          newQuantityAssigned: newQty??0,
          _id: element._id
        }]
      };
    } else {
      const sampleList = this.issueSampleForm.value.rows.map(row => ({ ...row, sampleId: this.sampleId }));
      data = { receiverType, sampleList };
    }

    this.sampleService.issueSample(data).subscribe({
      next: v => {
        if (v.success) {
          this.spinner.hide();
          if(!this.showLimitMessage) {
            this.toastr.success(v.message, 'Success');
          } else {
            this.toastr.success('Limit Updated Successfully','Success');
            this.showLimitMessage = false;
          }

          if (element) {
            element.limitEditMode = false;
            element.editMode = false;
            element.originalDistributorLimit = element.distributorLimit;
            element.originalQuantityAssigned = element.quantityAssigned;
            this.newQuantityAssignedMap[element._id] = 0;
          }

          this.getAllIssuedSampleToWholeSaler(null);
          this.getAllIssuedSampleToRetailer(null);
          this.clearRows();
          this.retailersMini();
          this.wholerSalersMini();
          this.getSingleSample();
          this.hideModel();
        } else {
          this.spinner.hide();
          if(!this.showLimitMessage) {
            this.toastr.error(v.message, 'Error');
          } else {
            this.toastr.error('Limit update failed, Kindly check your inputs.','Error');
            this.showLimitMessage = false;
          }
        }
      },
      error: e => this.toastr.error(e.message, 'Error'),
      complete: () => this.spinner.hide()
    });
  }




}
